<ng-container *ngIf="productDetailService.productDetail$ | async as product">
    <dl class="row">
        @if (showRelatedSpecifications) {
            @for (relatedProperty of product.relatedProperties | keyvalue; track relatedProperty.key) {
                <div class="property col-6 col-md-4">
                    <dt class="display-6 prop-headline">
                        {{ 'productDetail.property.' + relatedProperty.key | translate }}
                    </dt>

                    @if (relatedProperty.key !== 'primaryColor') {
                        @for (variant of $any(relatedProperty.value); track variant.value) {
                            <dd>
                                {{ variant.value }} {{ variant.unit?.text }}
                            </dd>
                        }
                    }

                    @if (relatedProperty.key === 'primaryColor') {
                        @for (color of $any(relatedProperty.value); track color.key) {
                            <dd class="color">
                                @if (color.key
                                    | matchColor
                                    : (settingsService.settings$ | async)?.productSettings
                                        ?.productColors; as colorModel) {

                                    <span class="color-display"
                                          [ngStyle]="colorModel.colorHexValue | colorStyle"></span>
                                    <span class="color-text">{{ colorModel.colorName }}</span>
                                }
                            </dd>
                        }
                    }
                </div>
            }
        }

        @for (property of product
            | normalizeProperties
            | removeDuplicateProps : (showRelatedSpecifications ? product.relatedProperties : {})
            | sortProperties
            | keyvalue : returnZero; track property.key) {
            <div class="property col-6 col-md-4"
                 [ngClass]="{
                    'col-md-12': property.key === 'washingInstructions' || property.key === 'maintenanceInstructions'
                 }">
                <dt class="display-6 prop-headline">
                    {{ 'productDetail.property.' + property.key | translate }}
                </dt>
                <dd *ngIf="property.key === 'primaryColor'; else regularProperty" class="color">
                    <ng-container
                        *ngIf="
                            property.value?.key
                                | matchColor
                                    : (settingsService.settings$ | async)?.productSettings?.productColors as colorModel
                        "
                    >
                        <span class="color-display" [ngStyle]="colorModel.colorHexValue | colorStyle"></span>
                        <span class="color-text">{{ colorModel.colorName }}</span>
                    </ng-container>
                </dd>
                <ng-template #regularProperty>
                    @if (property.value; as value) {
                        <dd>
                            {{ value.translation ? (value.translation | translate) : value.text }}
                            {{ value.unit ? value.unit : '' }}

                            @if ((property.key === 'breakWarranty' && product.breakWarranty) || (property.key === 'breakWarrantyRc' && product.breakWarrantyRc)) {
                                <ng-container [ngTemplateOutlet]="linkReadMore"></ng-container>
                            }
                        </dd>
                    }
                </ng-template>
            </div>
        }
    </dl>
</ng-container>

<ng-template #linkReadMore>
    <ng-container *ngIf="(settingsService.settings$ | async)?.pageReferences?.customerServicePage as link">
        <a class="kk-link" [title]="link.name || ''" [href]="link.url" [target]="link.target || '_blank'">{{
                'general.action.readMore' | translateSafe
            }}</a>
    </ng-container>
</ng-template>
